import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { github, nightOwl, vsDark } from "@code-surfer/themes";
const styledCenter = {
  width: "fit-content",
  textAlign: "center",
  borderBottom: '10px solid',
  borderImageSource: "linear-gradient(120deg, #1890ff, #db18ff)",
  borderImageSlice: 5
};
import useEffect from './useEffect.gif';
import useLayoutEffect from './useLayoutEffect.gif';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Image = makeShortcode("Image");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <CodeSurferColumns themes={[nightOwl]} mdxType="CodeSurferColumns">
      <Step mdxType="Step">
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "title=\"useLayoutEffect\" subtitle=\"before the browser has a chance to paint.\"",
            "title": "\"useLayoutEffect\"",
            "subtitle": "\"before",
            "the": true,
            "browser": true,
            "has": true,
            "a": true,
            "chance": true,
            "to": true,
            "paint.\"": true
          }}>{`const Message = ({ boxRef, children }) => {
  const msgRef = React.useRef(null);
  React.useEffect(() => {
    const rect = boxRef.current.getBoundingClientRect();
    msgRef.current.style.top = "\${rect.height + rect.top}px";
  }, []);

  return (
    <span ref={msgRef} className="msg">
      {children}
    </span>
  );
};
`}</code></pre>
        <Image src={useEffect} size='80%' mdxType="Image"></Image>
      </Step>
      <Step mdxType="Step">
        <pre><code parentName="pre" {...{
            "className": "language-jsx",
            "metastring": "title=\"useLayoutEffect\"",
            "title": "\"useLayoutEffect\""
          }}>{`const Message = ({boxRef, children}) => {
  const msgRef = React.useRef(null);
  React.useLayoutEffect(() => {
    const rect = boxRef.current.getBoundingClientRect();
    msgRef.current.style.top = "\${rect.height + rect.top}px";
  }, []);

  return <span ref={msgRef} className="msg">{children}</span>;
};

`}</code></pre>
        <Image src={useLayoutEffect} size='80%' mdxType="Image"></Image>
      </Step>
    </CodeSurferColumns>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      